import { ObjectClass } from '../enums';

import { IObjectClass } from './../interfaces/object-class';

export const ObjectClasses: IObjectClass[] = [
  {
    name: 'Account',
    value: ObjectClass.Account,
    icon: 'person',
    abr: 'A',
    pluralName: 'Accounts',
  },
  {
    name: 'Address',
    value: ObjectClass.Address,
    icon: 'person',
    pluralName: 'Addresses',
  },
  {
    name: 'File',
    value: ObjectClass.AssetFile,
    parentClass: 'asset',
    icon: 'insert_drive_file',
    abr: 'F',
    pluralName: 'Files',
  },
  {
    name: 'Tag',
    value: ObjectClass.Tag, icon:
      'person',
    pluralName: 'Tags',
  },
  {
    name: 'Type',
    value: ObjectClass.Type,
    icon: 'person',
    pluralName: 'Types',
  },
  {
    name: 'Status',
    value: ObjectClass.Status,
    icon: 'person',
    pluralName: 'Statuses',
  },
];

